import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_4 = {
  class: "min-h-0 flex-1 overflow-y-auto px-6 py-5"
};
const _hoisted_5 = {
  class: "grid grid-cols-1 gap-4 md:grid-cols-2"
};
const _hoisted_6 = {
  key: 0,
  class: "block md:col-span-2"
};
const _hoisted_7 = ["value"];
const _hoisted_8 = {
  class: "block md:col-span-2"
};
const _hoisted_9 = {
  class: "block"
};
const _hoisted_10 = {
  class: "block"
};
const _hoisted_11 = {
  class: "block"
};
const _hoisted_12 = {
  class: "block"
};
const _hoisted_13 = {
  class: "block"
};
const _hoisted_14 = {
  class: "block"
};
const _hoisted_15 = {
  class: "block md:col-span-2"
};
const _hoisted_16 = {
  class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
const _hoisted_17 = ["disabled"];
const _hoisted_18 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { createEnterpriseInvoicePlan, copyEnterpriseInvoicePlan } from '@/api/invoice';
import { parsePercentInput } from '../utils';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'InvoicePlanModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    basePlan: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'saved'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive(defaultForm());
    const submitting = ref(false);
    const parsedStartAmountTiers = ref([]);
    const parsedAmountToleranceRate = ref(null);
    const parsedProfitRateTolerancePoints = ref(null);
    const modalTitle = computed(() => props.mode === 'copy' ? '复制月度方案' : '新建月度方案');
    const basePlanLabel = computed(() => {
      if (!props.basePlan) return '-';
      return `${props.basePlan.planMonth || '-'} ${props.basePlan.planName || ''}`.trim();
    });
    function defaultForm() {
      return {
        basePlanId: null,
        planName: '',
        planMonth: '',
        amountToleranceRatePercent: '5.00',
        profitRateTolerancePointsPercent: '0.50',
        minChainSubjectCount: 10,
        maxChainSubjectCount: 20,
        amountStep: 100,
        startAmountTiersText: '200000,300000,500000,800000,1000000'
      };
    }
    function resetForm() {
      Object.assign(form, defaultForm());
      parsedStartAmountTiers.value = [];
      parsedAmountToleranceRate.value = null;
      parsedProfitRateTolerancePoints.value = null;
      if (props.mode === 'copy' && props.basePlan) {
        form.basePlanId = props.basePlan.id;
        form.planName = `${props.basePlan.planName || ''} 副本`.trim();
      }
    }
    function close() {
      emit('update:modelValue', false);
    }
    function parseStartAmountTiers() {
      const parts = form.startAmountTiersText.split(',').map(item => item.trim()).filter(Boolean);
      const amounts = parts.map(item => Number(item));
      if (parts.length === 0 || amounts.some(item => !Number.isFinite(item) || item <= 0)) {
        return null;
      }
      if (amounts.some(item => item % 100 !== 0)) {
        return 'INVALID_STEP';
      }
      return amounts;
    }
    function validate() {
      parsedStartAmountTiers.value = [];
      parsedAmountToleranceRate.value = null;
      parsedProfitRateTolerancePoints.value = null;
      if (!form.planName?.trim()) {
        ElMessage.warning('请填写方案名称');
        return false;
      }
      if (!form.planMonth) {
        ElMessage.warning('请选择方案月份');
        return false;
      }
      if (props.mode === 'copy') {
        if (!form.basePlanId) {
          ElMessage.warning('请选择要复制的方案');
          return false;
        }
        return true;
      }
      const amountToleranceRate = parsePercentInput(form.amountToleranceRatePercent);
      if (!Number.isFinite(amountToleranceRate) || amountToleranceRate < 0) {
        ElMessage.warning('请填写有效的额度偏差');
        return false;
      }
      parsedAmountToleranceRate.value = amountToleranceRate;
      const profitRateTolerancePoints = parsePercentInput(form.profitRateTolerancePointsPercent);
      if (!Number.isFinite(profitRateTolerancePoints) || profitRateTolerancePoints < 0) {
        ElMessage.warning('请填写有效的利润率偏差');
        return false;
      }
      parsedProfitRateTolerancePoints.value = profitRateTolerancePoints;
      const minCount = Number(form.minChainSubjectCount);
      const maxCount = Number(form.maxChainSubjectCount);
      if (minCount < 10) {
        ElMessage.warning('链路主体数最少为 10');
        return false;
      }
      if (maxCount < minCount) {
        ElMessage.warning('最大主体数不能小于最小主体数');
        return false;
      }
      if (Number(form.amountStep) !== 100) {
        ElMessage.warning('第一版金额步长固定为 100 元');
        return false;
      }
      const startAmountTiers = parseStartAmountTiers();
      if (startAmountTiers === 'INVALID_STEP') {
        ElMessage.warning('起始金额档位必须是 100 元整数倍');
        return false;
      }
      if (!startAmountTiers) {
        ElMessage.warning('请填写起始金额档位');
        return false;
      }
      parsedStartAmountTiers.value = startAmountTiers;
      return true;
    }
    function createPayload() {
      return {
        planName: form.planName.trim(),
        planMonth: form.planMonth,
        amountToleranceRate: parsedAmountToleranceRate.value,
        profitRateTolerancePoints: parsedProfitRateTolerancePoints.value,
        minChainSubjectCount: Number(form.minChainSubjectCount),
        maxChainSubjectCount: Number(form.maxChainSubjectCount),
        amountStep: Number(form.amountStep),
        startAmountTiers: parsedStartAmountTiers.value
      };
    }
    function copyPayload() {
      return {
        sourcePlanId: form.basePlanId,
        planName: form.planName.trim(),
        planMonth: form.planMonth
      };
    }
    async function submit() {
      if (submitting.value || !validate()) return;
      submitting.value = true;
      try {
        const plan = props.mode === 'copy' ? await copyEnterpriseInvoicePlan(copyPayload()) : await createEnterpriseInvoicePlan(createPayload());
        ElMessage.success(props.mode === 'copy' ? '方案已复制' : '方案已创建');
        emit('saved', plan);
        close();
      } catch (error) {
        console.error('Failed to save enterprise invoice plan', error);
        ElMessage.error(error.message || '保存方案失败');
      } finally {
        submitting.value = false;
      }
    }
    watch(() => props.modelValue, value => {
      if (value) resetForm();
    });
    watch(() => props.basePlan, () => {
      if (props.modelValue) resetForm();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "3xl",
        "panel-class": "max-h-[92vh]",
        "z-index": 70,
        scrollable: false,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(modalTitle.value), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(__props.mode === 'copy' ? '复制已有方案到目标月份。' : '创建新的企营增月度方案。'), 1)]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [...(_cache[8] || (_cache[8] = [_createElementVNode("span", {
          class: "sr-only"
        }, "关闭", -1), _createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("main", _hoisted_4, [_createElementVNode("div", _hoisted_5, [__props.mode === 'copy' ? (_openBlock(), _createElementBlock("label", _hoisted_6, [_cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("复制来源 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("input", {
          value: basePlanLabel.value,
          readonly: "",
          class: "form-input mt-1 w-full bg-slate-50"
        }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), _createElementVNode("label", _hoisted_8, [_cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("方案名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.planName = $event),
          type: "text",
          class: "form-input mt-1 w-full",
          placeholder: "请输入方案名称"
        }, null, 512), [[_vModelText, form.planName]])]), _createElementVNode("label", _hoisted_9, [_cache[11] || (_cache[11] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("方案月份 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.planMonth = $event),
          type: "month",
          class: "form-input mt-1 w-full"
        }, null, 512), [[_vModelText, form.planMonth]])]), __props.mode === 'create' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("label", _hoisted_10, [_cache[12] || (_cache[12] = _createElementVNode("span", {
          class: "form-label"
        }, "额度偏差（%）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.amountToleranceRatePercent = $event),
          type: "number",
          step: "0.01",
          min: "0",
          class: "form-input mt-1 w-full"
        }, null, 512), [[_vModelText, form.amountToleranceRatePercent]])]), _createElementVNode("label", _hoisted_11, [_cache[13] || (_cache[13] = _createElementVNode("span", {
          class: "form-label"
        }, "利润率偏差（百分点）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.profitRateTolerancePointsPercent = $event),
          type: "number",
          step: "0.01",
          min: "0",
          class: "form-input mt-1 w-full"
        }, null, 512), [[_vModelText, form.profitRateTolerancePointsPercent]])]), _createElementVNode("label", _hoisted_12, [_cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "form-label"
        }, "最少主体数", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.minChainSubjectCount = $event),
          type: "number",
          min: "10",
          class: "form-input mt-1 w-full"
        }, null, 512), [[_vModelText, form.minChainSubjectCount, void 0, {
          number: true
        }]])]), _createElementVNode("label", _hoisted_13, [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "form-label"
        }, "最多主体数", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.maxChainSubjectCount = $event),
          type: "number",
          min: "10",
          class: "form-input mt-1 w-full"
        }, null, 512), [[_vModelText, form.maxChainSubjectCount, void 0, {
          number: true
        }]])]), _createElementVNode("label", _hoisted_14, [_cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "form-label"
        }, "金额步长", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.amountStep = $event),
          type: "number",
          step: "100",
          class: "form-input mt-1 w-full"
        }, null, 512), [[_vModelText, form.amountStep, void 0, {
          number: true
        }]])]), _createElementVNode("label", _hoisted_15, [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("起始金额档位 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.startAmountTiersText = $event),
          type: "text",
          class: "form-input mt-1 w-full",
          placeholder: "200000,300000,500000"
        }, null, 512), [[_vModelText, form.startAmountTiersText]]), _cache[18] || (_cache[18] = _createElementVNode("p", {
          class: "mt-1 text-xs text-slate-500"
        }, "多个档位用英文逗号分隔，金额按 100 元取整。", -1))])], 64)) : _createCommentVNode("", true)])]), _createElementVNode("footer", _hoisted_16, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: submitting.value,
          onClick: close
        }, "取消", 8, _hoisted_17), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: submitting.value,
          onClick: submit
        }, _toDisplayString(submitting.value ? '保存中...' : '保存'), 9, _hoisted_18)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};